import React from 'react';
const stats = [['500+', 'Coaches'], ['1 + 5', 'Box Set & Bonuses'], ['4.9/5', 'Average rating'], ['Worldwide', 'Trusted globally']];
const notes = [['“I planned my entire season in one evening. Every session now has a clear objective.”', 'James M.', 'Lancashire, UK'], ['“The progressions are logical and the players can feel themselves improving.”', 'Coach David', 'Melbourne, Australia'], ['“Everything I need is right there. No more hours searching for drills.”', 'Priya T.', 'Auckland, NZ']];
export function ProofSection() {
  return <section className="bg-[#0A0A0A] px-5 pb-16" data-id="element-203" data-mp="3e01xnfj2n95z">
      <div className="mx-auto max-w-6xl" data-id="element-204" data-mp="3isl6y0aq7i4z">
        <div className="grid grid-cols-2 border border-[#d4af37]/25 bg-[#16161F] sm:grid-cols-4" data-id="element-205" data-mp="3isv2e3ejihi2">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-[#d4af37]/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-206" data-mp="3nt90asmfgb2d">
              <p className="font-display text-4xl font-bold uppercase text-[#d4af37] sm:text-5xl" data-id="element-207" data-mp="1jojzx462u2s">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-[#B0B0C0]" data-id="element-208" data-mp="15p2uvatibwj0">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-209" data-mp="vqdejmh9ek4v">
          {notes.map(([quote, name, location]) => <figure key={name} className="flex flex-col border border-[#E5E5EA] bg-white p-6" data-id="element-210" data-mp="ros6cefo6u10">
              <div className="mb-4 text-[#d4af37]" aria-label="5 out of 5 stars" data-id="element-211" data-mp="1oe99omr6k3zj">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#0A0A0A]" data-id="element-212" data-mp="1jfg6po9irvdm">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-[#E5E5EA] pt-4 text-sm font-bold text-[#0A0A0A]" data-id="element-213" data-mp="1amus8kcx8aul">
                {name}
                <span className="ml-2 text-xs font-medium text-[#5A5A66]" data-id="element-214" data-mp="275ai01e6xbvr">
                  {location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}